import { useCallback } from 'react'

import { useMutation } from '@tanstack/react-query'

import { type MergeRequest, type MergeMutationArgs } from './types'
import useMapConflictSelections from 'hooks/useMapConflictSelections'
import { type ConflictVersion } from 'components/ConflictVersionSelector/types'
import useGitContext from 'provider/GitProvider/useGitContext'
import useWorkingTreeClient from 'api/clients/useWorkingTreeClient'

const conflictMapping = new Map<ConflictVersion, string>([
  ['OURS', 'LOCAL'],
  ['THEIRS', 'REMOTE']
])

const useMerge = () => {
  const { project, branch } = useGitContext()
  const client = useWorkingTreeClient()
  const { map } = useMapConflictSelections(conflictMapping)

  const merge = useCallback(
    async ({ remoteCommitId, conflictSelections }: MergeMutationArgs) => {
      const body: MergeRequest = {
        remoteCommitId,
        conflictResolutions: map(conflictSelections)
      }

      const url = `projects/${project}/branches/${branch}/merges`
      const { status } = await client.post(url, body)
      return status
    },
    [branch, client, map, project]
  )

  return useMutation([project], merge)
}

export default useMerge
